<template>
  <div class="title-container">
    <h3 class="title">
      {{ pageTitle }}
      <div
        class="spinner-border spinner-theme_default"
        role="status"
        v-if="pageLoading"
      >
        <span class="sr-only">
          Loading...
        </span>
      </div>
    </h3>
    <div class="title-container__controls">
      <slot name="buttons"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pageTitle: {
      type: String,
      default: ''
    },
    pageLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>

</style>
